import React from "react";
import styled from "styled-components";
import { A, ACSS, H5, Small } from "@upsolve/ui";

const TRUST_ARTICLES = [
  {
    slug: "should-i-file-for-chapter-7-bankruptcy",
    title: "Should I File Chapter 7 Bankruptcy?",
    author: "The Upsolve Team",
  },
  {
    slug: "how-upsolve-works",
    href: "/learn/how-upsolve-works/",
    title: "How Upsolve's Free Chapter 7 Bankruptcy Filing Tool Works",
    author: "Ben Jackson",
  },
  {
    slug: "how-upsolve-is-free",
    title: "How Upsolve Is Free",
    author: "Jonathan Petts",
  },
  {
    slug: "reviews",
    href: "/reviews/",
    title: "Upsolve Reviews (4.9/5 Stars)",
    author: "Upsolve Users",
  },
];

const RelatedArticles = () => (
  <StyledRelatedArticles>
    <H5 as="p">Is Bankruptcy Right for You?</H5>
    <div>
      {TRUST_ARTICLES.map((article) => (
        <A key={article.slug} href={article.href ?? `/learn/${article.slug}/`}>
          <div className="ra__title">
            {article.title}
            <Small>
              <br />
              By {article.author}
            </Small>
          </div>
        </A>
      ))}
    </div>
  </StyledRelatedArticles>
);

const StyledRelatedArticles = styled.div`
  max-width: 1080px;
  margin: 0 auto 2em;
  & > p {
    width: 100%;
    text-align: center;
    color: ${(props) => props.theme.colors.black[300]};
  }
  & > div {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
    & > a {
      height: auto;
      border-radius: 4px;
      margin: 1em 0.5em;
      overflow: hidden;
      background: white;
      box-shadow: 0 4px 16px rgba(0, 0, 25, 0.1);
      display: flex;
      flex-direction: column;
      .ra__title {
        height: auto;
        padding: 1em;
        ${ACSS}
        small {
          opacity: 0.5;
        }
      }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
      grid-template-columns: repeat(1, 1fr);
      & > a {
        margin: 1em 2em;
      }
    }
  }
`;

export default RelatedArticles;
